module.exports = __webpack_public_path__ + "img/banner-overlay.629242a7.svg";